<ng-container *ngIf="visible">
  <div class="container-fluid carousel-spacing">
    <osn-shared-carousel-title
      *ngIf="showCarouselTitle; else titlePlaceholder"
      [title]="vm.titleToDisplay"
      [attr.aria-label]="vm.titleLocalized?.en"
      [link]="routerLink"
      [canNavigateOnTitleClick]="canNavigateOnTitleClick"
    ></osn-shared-carousel-title>
    <ng-template #titlePlaceholder>
      <div class="title-placeholder-container">
        <osn-shared-shimmer-loading [width]="100" [height]="titlePlaceholderHeight$ | async"></osn-shared-shimmer-loading>
      </div>
    </ng-template>
  </div>
  <osn-shared-carousel
    [vm]="carouselViewModel"
    [carouselTitle]="vm.titleLocalized?.en"
    (carouselItemSelect)="onCarouselItemSelect($event)"
    (carouselItemImpression)="onCarouselItemImpression($event)"
    [isInfinite]="!vm.isTop10"
  ></osn-shared-carousel>
</ng-container>
